import { defineFcm } from '../shared/factory';

export const FCM_FUTURE_SAP_MARKETING_CONSENT_REQUIRED = defineFcm('future_sap_marketing_consent_required')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'Start a Petition GDPR flow',
		description: 'This country feature config prompts the user to provide their marketing consent.',
	});
